import {PlayCircleFilled as AntdPlayCircleFilled} from '@ant-design/icons';

export default function PlayCircleFilled(props) {
  return <AntdPlayCircleFilled {...props} />;
}
